import { render } from "./alertBox.vue?vue&type=template&id=34c12eca&scoped=true"
import script from "./alertBox.vue?vue&type=script&lang=js"
export * from "./alertBox.vue?vue&type=script&lang=js"

import "./alertBox.vue?vue&type=style&index=0&id=34c12eca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c12eca"]])

export default __exports__